 <template>
    <div class="orologio-page">

        <div ref="background" :style="{
             'background-image':`url(${current.backgroundSrc })`
        }" class="background">
         </div>


        <div class="clock">
            <svg class="loading" data-v-511aa52e="" id="svg" height="100px" width="100" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 120 120">
                <circle data-v-511aa52e=""
                    r="50"
                    cx="60" cy="60"
                    stroke="var(--primary-color)"
                    stroke-width="1px"
                    fill="transparent"
                    stroke-dasharray="314"
                    :stroke-dashoffset="`${(1-percentage)*314}`">
                </circle>
            </svg>

             <router-link  :to="`/orologio/${route.title}`" v-for="(route, r) in routes"   :key="route.title" >
                <div class="date"
                    :key="i"
                    :style="{
                        'transform':`rotate(${(360/routes.length)*r}deg) translate(0px, calc( -26vh + 10px + 10px  ) )`
                    }"

                    :class="{'active':r<i, 'current':r==i}"
                    @mouseover="goingOn({path:route.title, i:r})" >
                    <div class="effect" >

                        <div class="dot-title" >
                            <div
                                
                                :style="{
                                    'transform':`rotate(${-(360/routes.length)*r}deg)`
                                }"
                                >
                                <!--  -->
                                {{route.title}}
                            </div>
                        </div>

                    </div>
                </div>
            </router-link>




            <div class="content">
                <div class="title"><span>{{current.title}}</span></div> 
                <div class="underline_title"></div> 
                <div class="sottotitolo"><span>{{current.sottotitolo}}</span></div>
            </div>

        </div>

    </div>
</template>

<script>

import hoverEffect from '../lib/hover-effect';

export default {
    name: 'orologio',
    components: {
    },
    props: {
        'routes': {
            default: [],
            type: Array
        }
    },
    data() {
        return {
            transition: null,
            fill : { gradient: ["var(--primary-color)"] },
            percentage: 0,
            selectedTitle: 'Esplora la storia',
            i: 0,
        }
    },
    mounted() {
        this.goingOn({path:this.routes[0].title, i:0}, true);

    },
    methods: {
        goingOn(data, force) {
           
            if(data.i == this.i && !force) return;

            this.percentage =  1/this.routes.length*data.i;
            // this.selectedTitle = data.path; 
            
            this.selectedTitle = data.path; this.i = data.i;

            // let oldTransition = this.transition;


            // // this.i = data.i; return;
            // this.transition =  new hoverEffect({
            //     parent: this.$refs.background,
            //     image1:this.routes[this.i].backgroundSrc,
            //     image2:this.routes[data.i].backgroundSrc,
            //     displacementImage:'/assets/transition.png',
            //     intensity:0.2,
            //     speedIn:1.5,
            //     speedOut:1.5,
            //     hover:false,
            // });

            // this.transition.next();

            // setTimeout(function() {
            //     if(oldTransition) {
            //         oldTransition.element.remove();
            //     }
            // }, 1500);



            // this.i = data.i;
        }
    },
    computed: {
        current() {
            return   this.routes[this.i] || { 
                backgroundSrc: '',
                title: 'Inizia',
                sottotitolo: ''
            }
        }
    }
}
</script>
<style scoped>
.title {
    font-weight: bold;
    font-size: 1.5em;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%; 
    height: 40%;

}

.title span {
    position: absolute;
    text-align: center;
    width: 100%; 
    bottom: 0;
    left: 0;
}

.underline_title{ 
    background-color: var(--secondary-color);
    height: 10px;
    width: 15vw; 
    left: calc(50% - 7.5vw);
    position: absolute;
    top: calc(50% - 5px);
}

.sottotitolo {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: calc(40%);
    text-align:center;
    left: 0;
    font-size: .7em;
}


.date {
    position: absolute;
    top: calc(50% - 12px);
    left: calc(50% - 12px);
    color: var(--primary-color);
    height: 18px;
    width: 18px;
    border-radius:  100%;
    border: 2px solid var(--primary-color);
    text-decoration: none;
}

.effect {
    background-color: transparent;
    height: 5px;
    width: 5px;
    border-radius: 100%;
    transition-duration: .2s;
    position: absolute;
    top: calc(50% - 2.5px);
    left: calc(50% - 2.5px);
    transform-origin: center;
}

.effect * {

    transform-origin: center;
}

.date:hover, .active/*, .current*/    {
    transition-duration: .2s;
    background-color: rgba(255, 255, 255, 1);
}



.date:hover, .current    {
    transition-duration: .2s;
    background-color: var(--secondary-color);
    border-color: var(--secondary-color); 
    /* color: var(--secondary-color); */
}


.date:hover .dot-title{
    
    text-decoration: underline;
}

.background {
    position: absolute;
    width: 100%;
    height: 100%;
    filter: brightness(35%);
    background-size: cover;
}

.orologio-page {
    width: 100%;
    height: 100vh;
    z-index: 11;
}
.clock {
    position: absolute;
    z-index: 12;
    /* background-color: rgba(255, 255, 255, 0.205); */
    /* backdrop-filter:  blur(15px); */
    border-radius: 100%;
    height: 50vh ;
    width: 50vh;
    top: calc(50% - 25vh);
    left: calc(50% - 25vh);
    display: flex;
    align-items: center;
    justify-content: center; 
}

.loading {
    position: absolute;
    width: 57vh;
    height: 57vh;
    left: calc(50% - 28.5vh );
    top: calc(50% - 28.5vh );

    
    /* width: calc( 2 * ( 26vh + 44.5px ));
    height: calc( 2 * ( 26vh + 44.5px ));
    left: calc(50% -  ( 26vh + 44.5px ) );
    top: calc(50% - ( 26vh + 44.5px ) ); */

    
    transform: rotate(-90deg) scaleZ(-1);
}

.loading circle {

    transition: stroke-dashoffset .3s linear;
}

.content {
    font-size: 2em;
    text-align: center;
    position: absolute;
    width: 40vh;
    height: 40vh;
    pointer-events: none;
}
.content * {
    pointer-events: none;
    
    /* font-family: 'Orbitron', sans-serif; */
}
.dot-title {
    transform: translate(-50%, -100px);
    position: absolute;
    top: 0;
}

.dot-title > div {
    /* background-color: rgba(255, 255, 255, 0.37); */
    padding: 10px;
    border-radius: 2px;
    white-space: nowrap;
}


</style>